import { t } from "i18next";
import { useSnapshot } from "valtio";

import React from "react";

import { kioskStore } from "@pages/Kiosk/store";

import "./index.css";

export function AuthenticationLoadingContent(): JSX.Element {
    const { selectedAuthMode, numericKeyboardInputValue, qrCodeValue } =
        useSnapshot(kioskStore);

    const isLoyaltyCardAuthMode = selectedAuthMode === "loyaltyCard";

    const authenticatedValue =
        isLoyaltyCardAuthMode && qrCodeValue !== ""
            ? qrCodeValue
            : numericKeyboardInputValue;

    return (
        <div className="authentication-loading-content__clz">
            <div className="authentication-loading-spinner__clz">
                <div className="authentication-loading-ring__clz authentication-loading-ring-1__clz" />
                <div className="authentication-loading-ring__clz authentication-loading-ring-2__clz" />
            </div>
            <div className="authentication-loading-title__clz">
                {isLoyaltyCardAuthMode
                    ? t("Checking your fidelity card")
                    : t("Connecting to your account")}
                <span className="authentication-loading-dots__clz">
                    <span>.</span>
                    <span>.</span>
                    <span>.</span>
                </span>
            </div>
            <div className="authentication-loading-subtitle__clz">
                {t("Please wait a moment")}
            </div>
            {authenticatedValue !== "" ? (
                <div className="authentication-loading-value__clz">
                    {authenticatedValue}
                </div>
            ) : null}
        </div>
    );
}
